export function hasValue(val) {
    return (val === 0 || val)    
}